import { useParams } from "react-router-dom";
import ApiService from "../../../services/api";
import { useContext, useEffect, useState } from "react";
import { Badge, Col, Container, Row } from "react-bootstrap";
import "../css/artistic_direction_page.css";
import { AuthContext } from "../../../services/auth";

const ArtisticDirectionPage = () => {
  const { isEnglish } = useContext(AuthContext);
  const [categorys, setCategorys] = useState([]);
  const [subcategory, setSubcategory] = useState({});
  const [Loading, setLoading] = useState(true);
  const { dataCategory } = useParams();

  const fetchCategory = async () => {
    const category = await ApiService.getDirectionCategory(dataCategory);
    const sortedCategory = category.sort((a, b) => {
      return parseInt(b.year) - parseInt(a.year);
    });
    const subcategories = await ApiService.getSubcategories();
    setSubcategory(subcategories);
    setCategorys(sortedCategory);
    setLoading(false);
  };

  useEffect(() => {
    fetchCategory();
  }, [dataCategory]);

  if (Loading) {
    return;
  }

  if (!categorys) {
    return;
  }

  return (
    <Container fluid className="p-0 m-0 mb-5">
      <Container className="padding_custom">
        <h2 className="mt-5 text-center section-title">
          {categorys[0].category.toUpperCase()}
        </h2>
        <div className="border-custom mt-3"></div>
        {subcategory.map((subcategory) => {
          return (
            <Container fluid key={subcategory.id}>
              {categorys.filter((data) => data.subcategory === subcategory.name)
                .length > 0 && (
                <>
                  <h3 className="py-4 pt-5 text-center section-subtitle">
                    {isEnglish ? subcategory.name_eng : subcategory.name}
                  </h3>
                </>
              )}
              <Row className="">
                {categorys
                  .filter((filters) => filters.subcategory === subcategory.name)
                  .map((data) => {
                    return (
                      <Col
                        className="container-element-artistic py-4 "
                        key={data.id}
                      >
                        <a
                          href={data.link}
                          className="text-decoration-none text-black "
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Container
                            className="py-4 m-0 bg-coustom-artistic-page text-center h-100"
                            fluid
                          >
                            <h6 className="py-1 fs-6 section-text">
                              {data.year}
                            </h6>
                            <h5 className="text_compositions pb-2">
                              {isEnglish ? data.title_eng : data.title}
                            </h5>
                            <Container className="d-flex justify-content-center align-items-center">
                              <Row className="w-100 text-center m-0 container-badge-artistic-direction-page">
                                {data.artists.map((artist) => {
                                  return (
                                    <Col
                                      key={artist.id}
                                      className="py-2 m-0 h-100 container-body-page-artistic"
                                    >
                                      {artist.link && (
                                        <Badge
                                          onClick={() =>
                                            window.open(artist.link)
                                          }
                                          bg=""
                                          className="badge-color-artistic-direction-page p-2"
                                          pill
                                        >
                                          <p className="fs-custom m-0 text-center section-text">
                                            {artist.name}
                                          </p>
                                        </Badge>
                                      )}
                                      {!artist.link && (
                                        <Badge
                                          bg=""
                                          className="badge-color-artistic-direction-page p-2"
                                          pill
                                        >
                                          <p className="fs-custom m-0 text-center section-text">
                                            {artist.name}
                                          </p>
                                        </Badge>
                                      )}
                                    </Col>
                                  );
                                })}
                              </Row>
                            </Container>
                            <div className="mt-4 bottom-0">
                              <p className="mt-3 section-text">
                                {isEnglish
                                  ? data.producer_eng
                                  : data.producer}
                              </p>
                            </div>
                          </Container>
                        </a>
                      </Col>
                    );
                  })}
              </Row>
            </Container>
          );
        })}
      </Container>
    </Container>
  );
};
export default ArtisticDirectionPage;
